module.exports = __webpack_public_path__ + "img/logo-nav.b4c0d7b4.png";